import React, { useState } from "react";
import {
  FaCar,
  FaUserTie,
  FaHandshake,
  FaHeadset,
  FaPhoneAlt,
  FaEnvelope,
  FaWhatsapp,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Career = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    position: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const text = `
🚖 Rising Cab Service - Career Application

👤 Name: ${formData.name}
📱 Mobile: ${formData.mobile}
📧 Email: ${formData.email}
💼 Position: ${formData.position}

📝 Message:
${formData.message}
`;

    const whatsappURL = `https://wa.me/919272511548?text=${encodeURIComponent(
      text
    )}`;

    window.open(whatsappURL, "_blank");
  };

  return (
    <div className="career-page">

      {/* HERO */}
    <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            zIndex: 1, }}></div>

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Career </h1>
          </div>
        </div>
      </div>

      <section className="career-section container">

        {/* GRID */}
        <div className="row g-4">

          {/* LEFT - INFO */}
          <div className="col-md-6">

            <div className="career-card">
              <FaHandshake className="icon" />
              <h3 className="text-white">Business Partner</h3>
              <p>Start your own transport business with guaranteed support and bookings.</p>
            </div>

            <div className="career-card">
              <FaCar className="icon" />
              <h3 className="text-white">Driver Partner</h3>
              <p>Earn daily income with flexible working hours and steady rides.</p>
            </div>

            <div className="career-card">
              <FaUserTie className="icon" />
              <h3 className="text-white">Travel Consultant</h3>
              <p>Help customers with booking, routes and travel planning.</p>
            </div>

            <div className="career-card">
              <FaHeadset className="icon" />
              <h3 className="text-white">Customer Support</h3>
              <p>Handle customer queries and ensure smooth ride experience.</p>
            </div>

          </div>

          {/* RIGHT - FORM */}
          <div className="col-md-6">

            <div className="career-form-box">

              <h2>Apply Now</h2>

              <form onSubmit={handleSubmit}>

                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  onChange={handleChange}
                  required
                />

                <input
                  type="tel"
                  name="mobile"
                  placeholder="Mobile Number"
                  onChange={handleChange}
                  required
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  onChange={handleChange}
                  required
                />

                <select name="position" onChange={handleChange} required>
                  <option value="">Select Position</option>
                  <option>Driver Partner</option>
                  <option>Travel Consultant</option>
                  <option>Business Partner</option>
                  <option>Customer Support</option>
                </select>

                <textarea
                  name="message"
                  rows="4"
                  placeholder="Tell us about yourself"
                  onChange={handleChange}
                />

                <button type="submit">
                  <FaWhatsapp /> Submit via WhatsApp
                </button>

              </form>
            </div>
          </div>
        </div>

        {/* CONTACT SECTION */}
        <div className="row mt-5">

          <div className="col-md-6">
            <div className="contact-box">
              <FaPhoneAlt />
              <a href="tel:+919272511548">+91 9272511548</a>
            </div>

            <div className="contact-box">
              <FaWhatsapp />
              <a href="https://wa.me/919272511548" target="_blank">
                WhatsApp Chat
              </a>
            </div>

            <div className="contact-box">
              <FaEnvelope />
              <a href="mailto:booking@risingcabservice.com">
                booking@risingcabservice.com
              </a>
            </div>
          </div>

          <div className="col-md-6">
            <div className="contact-address">
              <FaMapMarkerAlt />
              <p>
                Rising Cab Service <br />
                A Unit of Atithya Dining LLP,
901, 902 Deron Height, <br/> Baner Rd,
Above Ranka Jewelers, Pune,
Maharashtra -411069.

              </p>
            </div>
          </div>

        </div>

      </section>
    </div>
  );
};

export default Career;